import { useQuery } from '@apollo/client'
import React, { useContext, useEffect, useRef, useState } from 'react'
import {
  DELETE_PROCESS_REQUEST,
  GET_ALL_PROCESS_REQUESTS,
} from '../../../../graphql/Catalog/Processes/Requests/ProcessesRequests'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import ContentHeader from '../../../Layout/ContentHeader'
import LayoutTable from '../../../Global/LayoutTable'
import ModalContent from '../../../Global/ModalContent'
import ModalStatusRequests from './ModalStatus/ModalStatusRequests'
import ProgressBarStatusRequest from '../../../Global/ProgressBarStatusRequest'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { filter } from 'lodash'
import { GET_ALL_PROCESSES } from '../../../../graphql/Catalog/Processes/Processes'
import { GET_ALL_PROCESSES_CATEGORIES } from '../../../../graphql/Catalog/Processes/ProcessesCategories'
import { GET_ALL_PROCESSES_SUBCATEGORIES_BY_PROCESS_CATEGORY_ID } from '../../../../graphql/Catalog/Processes/ProcessesSubCategories'
import ProgressBarStatusReport from '../../../Global/ProgressBarStatusReport'
import { GET_ALL_STATUS_ROLES_BY_TYPE_STATUS_OF_USER_CONTEXT } from '../../../../graphql/Catalog/Status/statusRoleVisibility'
import { AuthContext } from '../../../../Auth/AuthContext'
import { objNameRoles } from '../../../../const/constRoles'
import { omit } from 'lodash'

const ManageRequests = () => {
  const { user } = useContext(AuthContext)

  const [statusOfRole, setStatusOfRole] = useState([])
  
  const refModalStatus = useRef(null)
  const [dataTable, setDataTable] = useState([])
  const [count, setCount] = useState(0)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: '',
    limit: 10,
    offset: 0,
    filter: {
      status_id: null,
      start_date: null,
      end_date: null,
      process_id: null,
      process_category_id: null,
      process_sub_category_id: null,
    },
  })

  //MODAL CONTENT
  const [closeModal, setCloseModal] = useState(false)
  const [modalContent, setModalContent] = useState({
    title: '',
    content: null,
    size: 'extra',
    modalId: null,
  })

  const { loading, error, data, refetch } = useQuery(GET_ALL_PROCESS_REQUESTS, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      filter: pagePagination.filter,
    },
    fetchPolicy: 'no-cache',
  })

  const {
    loading: loadingProcesses,
    error: errorProcesses,
    data: dataProcesses,
  } = useQuery(GET_ALL_PROCESSES, {
    variables: {
      searchQuery: '',
      limit: 100,
      offset: 0,
    },
    fetchPolicy: 'no-cache',
  })

  const {
    loading: loadingProcessesCategories,
    error: errorProcessesCategories,
    data: dataProcessesCategories,
  } = useQuery(GET_ALL_PROCESSES_CATEGORIES, {
    variables: {
      searchQuery: '',
      limit: 100,
      offset: 0,
      filterCategory: true,
      processId: pagePagination?.filter?.process_id
        ? pagePagination.filter.process_id
        : null,
    },
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataProcesessSubCategories,
    loading: loadingProcesessSubCategories,
    error: errorProcesessSubCategories,
    refetch: refetchSubCategories,
  } = useQuery(GET_ALL_PROCESSES_SUBCATEGORIES_BY_PROCESS_CATEGORY_ID, {
    skip: user?.role === objNameRoles.gestor_tramites, // Skip query if condition is met
    variables: {
      processCategoryId: pagePagination?.filter?.process_category_id
        ? pagePagination.filter.process_category_id
        : 0,
      filterSubCategories: user?.role !== objNameRoles.gestor_tramites,
    },
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataStatusRole,
    loading: loadingStatusRole,
    error: errorStatusRole,
  } = useQuery(GET_ALL_STATUS_ROLES_BY_TYPE_STATUS_OF_USER_CONTEXT, {
    variables: {
      type_status: 'process',
    },
    fetchPolicy: 'no-cache',
  })

  const [filterOptions, setFilterOptions] = useState({
    processes: [],
    processesCategories: [],
    processesSubCategories: [],
  })

  useEffect(() => {
    const storedSearchQuery = localStorage.getItem('seachQueryProcesses')
    const storedFilter = localStorage.getItem('filterProcesses')
    setPagePagination((prevState) => ({
      ...prevState,
      searchQuery: JSON.parse(storedSearchQuery),
      filter: JSON.parse(storedFilter),
    }))
  }, [])

  //PERSIST FILTERS AND SEARCHQUERY
  useEffect(() => {
    localStorage.setItem(
      'seachQueryProcesses',
      JSON.stringify(pagePagination.searchQuery)
    )
  }, [pagePagination.searchQuery])

  useEffect(() => {
    localStorage.setItem(
      'filterProcesses',
      JSON.stringify(pagePagination.filter)
    )
  }, [pagePagination.filter])

  useEffect(() => {
    try {
      if (loading || loadingStatusRole) return
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      const infoProcesses = data.getAllProcessesRequests.rows.map(
        (processRequest) => {
          return {
            id: processRequest.id,
            folio: processRequest.folio,
            'folio externo': processRequest.external_folio,
            tramite: processRequest.ProcessesRequestsToProcesses
              ? processRequest.ProcessesRequestsToProcesses.name
              : 'N/A' || 'N/A',
            dependencias: processRequest.ProcessesRequestsToCategories
              ? processRequest.ProcessesRequestsToCategories.name
              : 'N/A' || 'N/A',
            'Tipo de trámite': processRequest.ProcessesRequestsToSubCategories
              ? processRequest.ProcessesRequestsToSubCategories.name
              : 'N/A' || 'N/A',
            subcategoría: processRequest.ProcessesRequestToSubCategoriesChildren
              ? processRequest.ProcessesRequestToSubCategoriesChildren.name
              : 'N/A' || 'N/A',
            ciudadano: processRequest.ProcessesRequestsToCitizens
              ? `${processRequest.ProcessesRequestsToCitizens.name} ${processRequest.ProcessesRequestsToCitizens.last_name}`
              : 'Sin ciudadano' || 'Sin ciudadano',
            'fecha de solicitud': (
              <>
                {!processRequest?.request_date
                  ? 'N/A'
                  : moment(Number(processRequest.request_date)).format(
                      'dddd D [de] MMMM [de] YYYY HH:mm [hrs]'
                    )}
              </>
            ),
            Estatus: (
              <ProgressBarStatusReport
                statusReport={processRequest?.ProcessesRequestsToStatus}
              />
            ),
            status__omit: processRequest.ProcessesRequestsToStatus,
            acciones: (
              <div className="my-3 d-flex flex-column acciones">
                <Link
                  className="btn btn-migrates btn-sm mb-1"
                  to={`managerequests/details/${processRequest.id}/show`}
                >
                  <i className="fas fa-eye mr-1" /> Ver
                </Link>
                {foundStatusCurrentInStatusRole(processRequest?.status_id) && (
                  <button
                    className="btn btn-migrates btn-sm"
                    onClick={() =>
                      handleProcess(processRequest.id, processRequest)
                    }
                  >
                    Procesar
                  </button>
                )}
              </div>
            ),
            // acciones: (
            //   <>
            //     <div className="my-3 d-flex flex-column acciones">
            //       <Link
            //         className="btn btn-accept-white btn-sm mb-1"
            //         to={`managerequests/details/${processRequest.id}/show`}
            //       >
            //         <i className="fas fa-eye mr-1" /> Ver
            //       </Link>
            //       {processRequest.ProcessesRequestsToStatus.key !==
            //         'approved' &&
            //         processRequest.ProcessesRequestsToStatus.key !==
            //           'rejected' &&
            //         processRequest.ProcessesRequestsToStatus.key !==
            //           'request_cancel' && (
            //           <button
            //             className="btn btn-accept btn-sm"
            //             onClick={(e) =>
            //               handleProcess(
            //                 e,
            //                 processRequest.id,
            //                 processRequest.ProcessesRequestsToStatus.name,
            //                 processRequest.ProcessesRequestsToStatus.key,
            //                 processRequest.ProcessesRequestsToStatus.id,
            //                 processRequest.ProcessesRequestsToStatus
            //                   .StatusTransitions,
            //                 processRequest.ProcessesRequestsToProcesses
            //                   .ProcessesToProcessRequirements || []
            //               )
            //             }
            //           >
            //             Procesar
            //           </button>
            //         )}
            //     </div>
            //   </>
            // ),
          }
        }
      )

      setDataTable(infoProcesses)
      setCount(data.getAllProcessesRequests.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, loading, error, statusOfRole])

  useEffect(() => {
    if (loadingProcesses) return
    if (errorProcesses)
      return toastSweetAlert({
        mode: 'error',
        message: errorProcesses.message,
      })

    if (!dataProcesses?.getAllProcesses?.rows) return

    const processes = dataProcesses?.getAllProcesses?.rows.map((item) => {
      return {
        value: item.id,
        label: item.name,
      }
      // return (
      //   <option value={item.id} key={item.id}>
      //     {item?.name}
      //   </option>
      // )
    })

    setFilterOptions((prevOptions) => ({
      ...prevOptions,      
      processes,
    }))
  }, [dataProcesses, loadingProcesses, errorProcesses])

  useEffect(() => {
    if (loadingProcessesCategories) return
    if (errorProcessesCategories)
      return toastSweetAlert({
        mode: 'error',
        message: errorProcessesCategories.message,
      })

    const processesCategories =
      dataProcessesCategories.getAllProcessesCategories.rows.map((item) => {
        return {
          value: item.id,
          label: item.name,
        }
        // return (
        //   <option value={item.id} key={item.id}>
        //     {item?.name}
        //   </option>
        // )
      })

    setFilterOptions((prevOptions) => ({
      ...prevOptions,
      processesCategories,
    }))
  }, [
    dataProcessesCategories,
    loadingProcessesCategories,
    errorProcessesCategories,
  ])

  useEffect(() => {
    if (loadingProcesessSubCategories) return
    if (errorProcesessSubCategories)
      return toastSweetAlert({
        mode: 'error',
        message: errorProcesessSubCategories.message,
      })

    const processesSubCategories =
      dataProcesessSubCategories?.getAllProcessesSubCategoriesByProcessCategoryId?.map(
        (item) => {
          return {
            value: item.id,
            label: item.name,
          }
          // return (
          //   <option value={item.id} key={item.id}>
          //     {item?.name}
          //   </option>
          // )
        }
      )

    setFilterOptions((prevOptions) => ({
      ...prevOptions,      
      processesSubCategories,
    }))
  }, [
    dataProcesessSubCategories,
    loadingProcesessSubCategories,
    errorProcesessSubCategories,
    pagePagination.filter.process_category_id,
  ])

  useEffect(() => {
    if (modalContent.modalId) {
      document.getElementById(`spanModal${modalContent.modalId}`).click()
    }
  }, [modalContent])

  useEffect(() => {
    if (closeModal) {
      document.getElementById(`spanModal${modalContent.modalId}`).click()
      setModalContent({
        title: '',
        content: null,
        modalId: null,
        size: 'extra',
      })
      setCloseModal(false)
    }
  }, [closeModal])

  useEffect(() => {
    if (!loadingStatusRole && !errorStatusRole) {
      if (dataStatusRole) {
        setStatusOfRole(
          dataStatusRole.getAllStatusRoleByTypeStatusOfUserContext
        )
      }
    }
  }, [dataStatusRole, loadingStatusRole, errorStatusRole])

  const foundStatusCurrentInStatusRole = (status_id) => {
    return statusOfRole.find((item) => item.status_id === status_id)
  }

  const handleProcess = (id, row) => {
    setModalContent({
      title: `Procesar solicitud ${row.folio}`,
      content: (
        <>
          <ModalStatusRequests
            requestId={id}
            currentStatusId={row?.ProcessesRequestsToStatus?.id}
            reportFolio={row?.folio}
            externalFolio={row?.external_folio}
            groupCategory={row?.ProcessesRequestsToCategories?.name}
            currentStatusName={row?.ProcessesRequestsToStatus?.name}
            setCloseModal={setCloseModal}
            refetchMain={refetch}
            maxFiles={3}
            // FilesRequirements={documentsRequirements}
          />
        </>
      ),
      modalId: 'modalStatusRequests',
      size: 'large',
    })
  }

  const handleFilters = (e, field) => {
    if (field === 'from') field = 'start_date'
    else if (field === 'to') field = 'end_date'

    const filterSelected =
      field === 'start_date' || field === 'end_date'
        ? e.target.value
        : e
        ? e.value
          : null
    
    console.log({
      field,
      role: user?.role,
      gestorTramites: objNameRoles.gestor_tramites,
    })

    if (field === 'process_category_id') {
      
      setFilterOptions((prevOptions) => ({
        ...prevOptions,
        processesSubCategories: [],
      }))

      refetchSubCategories({
        processCategoryId: e ? e.value : null,
        filterSubCategories: user?.role !== objNameRoles.gestor_tramites,
      })
    }

    setPagePagination((prevState) => ({
      ...prevState,
      filter: {
        ...prevState.filter,
        ...(field === 'process_category_id' && {
          process_sub_category_id: null,
        }),
        [field]: filterSelected,
        ...(field === 'process_id' &&
          !filterSelected && {
            process_category_id: null,
            process_sub_category_id: null,
          }),
      },
    }))

    // ...pagePagination,
    // filter: {
    //   ...pagePagination.filter,
    //   ...(field === 'process_category_id' && {
    //     process_sub_category_id: null,
    //   }),
    //   [field]: filterSelected,
    //   // [field]:
    //   //   field === 'process_id' ||
    //   //   field == 'process_category_id' ||
    //   //   field == 'process_sub_category_id'
    //   //     ? parseInt(filterSelected)
    //   //     : filterSelected,
    // },
  }

  const handleClearFilters = () => {
    setPagePagination((prevState) => ({
      ...prevState,
      searchQuery: '',
      filter: {
        status_id: null,
        start_date: null,
        end_date: null,
        process_id: null,
        process_category_id: null,
        process_sub_category_id: null,
      },
    }))
    localStorage.removeItem('seachQueryProcesses')
    localStorage.removeItem('filterProcesses')    
    const searchBar = document.getElementById('searchBar')
    searchBar.value = ''    
    const dateInputFrom = document.getElementById('dateInputFrom')
    if (dateInputFrom) dateInputFrom._flatpickr.setDate('', true)
    const dateInputTo = document.getElementById('dateInputTo')
    if (dateInputTo) dateInputTo._flatpickr.setDate('', true)
    
  }
  return (
    <>
      <ContentHeader
        title="Gestión de solicitudes"
        windowTitle="Gestión de solicitudes"
        breadcrumb=""
      />
      <LayoutTable
        hideId
        title="Lista de solicitudes"
        data={dataTable}
        totalCount={count}
        loadingData={loading}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        refetchFunctionQueries={refetch}
        exportImportButton={false}
        filterBarValue={pagePagination.searchQuery}
        // editText="Procesar"
        // actionBtnEdit={(id, row) => handleProcess(id, row)}
        filterChoosen={[
          {
            id: 'process_id',
            name: 'process_id',            
            options: filterOptions.processes,
            placeholder: 'Selecciona un Trámite',
            isClearable: true,
            isSearchable: true,
            onChange: (value) => handleFilters(value, 'process_id'),
            value: pagePagination.filter.process_id,            
            noOptionsMessage: () => 'No hay resultados para mostrar',
            classNameFull: !pagePagination?.filter?.process_category_id
              ? 'col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-3 pl-0 pr-3'
              : 'col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-3 pl-0 pr-3',
          },
          {
            condition: !pagePagination?.filter?.process_id,
            id: 'process_category_id',
            name: 'process_category_id',
            options: filterOptions.processesCategories,
            placeholder: 'Dependencias',
            isClearable: true,
            isSearchable: true,
            onChange: (value) => handleFilters(value, 'process_category_id'),
            value: pagePagination.filter.process_category_id,
            noOptionsMessage: () => 'No hay resultados para mostrar',
            classNameFull: !pagePagination?.filter?.process_category_id
              ? 'col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-3 pl-0 pr-3'
              : 'col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-3 pl-0 pr-3',
          },
          {
            condition: !pagePagination?.filter?.process_category_id,
            id: 'process_sub_category_id',
            name: 'process_sub_category_id',
            options: filterOptions.processesSubCategories,
            placeholder: 'Tipo de trámite',
            isClearable: true,
            isSearchable: true,
            onChange: (value) =>
              handleFilters(value, 'process_sub_category_id'),
            value: pagePagination.filter.process_sub_category_id,
            noOptionsMessage: () => 'No hay resultados para mostrar',
            classNameFull: !pagePagination?.filter?.process_category_id
              ? 'col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-3 pl-0 pr-3'
              : 'col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-3 pl-0 pr-3',
          },
        ]}
        gql={DELETE_PROCESS_REQUEST}
        hideActions
        // filter
        // filterOnChange={(e) => handleFilters(e, 'process_id')}
        // filterOptions={filterOptions?.processes}
        // filterDefaultOptionText="Tipo tramite"
        // defaultValueSelect={
        //   pagePagination.filter.process_id
        //     ? `${pagePagination.filter.process_id}`
        //     : null
        // }
        // filterSecond
        // filterOnChangeSecond={(e) => handleFilters(e, 'process_category_id')}
        // filterOptionsSecond={filterOptions?.processesCategories}
        // filterDefaultOptionTextSecond="Categoría"
        // filterThird={
        //   pagePagination?.filter?.process_category_id
        //     ? user?.role !== objNameRoles.gestor_tramites
        //     : false
        // }
        // filterOnChangeThird={(e) => handleFilters(e, 'process_sub_category_id')}
        // filterOptionsThird={filterOptions?.processesSubCategories}
        // filterDefaultOptionTextThird="Subcategoría"
        cols_search="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
        cols_search_div="col-12"
        // cols_filters={
        //   !pagePagination?.filter?.process_category_id
        //     ? 'col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-3'
        //     : 'col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-3'
        // }
        cols_filters_div="col-12"
        isFilterRangeShow
        filterRangeProps={{
          from: {
            value: pagePagination.filter.start_date,
            id: 'dateInputFrom',
            // label: 'Fecha inicio',
          },
          to: {
            value: pagePagination.filter.end_date,
            id: 'dateInputTo',
            // label: 'Fecha fin',
          },
          changeFilterDateRange: handleFilters,
        }}
        headerComponents={
          <>
            <button
              className="btn btn-purple btn-sm"
              title="Limpiar filtros"
              onClick={handleClearFilters}
            >
              <i className="fas fa-times" /> Limpiar filtros
            </button>
          </>
        }
      />

      <span
        id={`spanModal${modalContent.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modalContent.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={refModalStatus}
      />

      <ModalContent
        idModal={modalContent.modalId}
        title={modalContent.title}
        size={modalContent.size}
        onClose={() => {
          setModalContent({
            title: '',
            content: null,
            modalId: null,
            size: 'extra',
          })
        }}
        content={modalContent.content}
      />
    </>
  )
}

export default ManageRequests
